import { z } from "zod";

export const UserProfileSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  displayName: z.string(),
});
export type UserProfile = z.infer<typeof UserProfileSchema>;
